import { render, staticRenderFns } from "./animated-numbers.vue?vue&type=template&id=0e15da3b&scoped=true"
import script from "./animated-numbers.vue?vue&type=script&lang=js"
export * from "./animated-numbers.vue?vue&type=script&lang=js"
import style0 from "./animated-numbers.vue?vue&type=style&index=0&id=0e15da3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e15da3b",
  null
  
)

export default component.exports